// import { LocalNotificationsPluginWeb } from '@capacitor/core';
import { EmployeeRolesEnum } from '@analytics-soa/shared-models';
export class CreateUserDto {
    Id?: number;
    username:string;
    password:string;
    clientCode:string;
    email:string;
    divisionId:number;
    employeeRole:EmployeeRolesEnum;
    isActive: boolean;
    createdAt : Date | any;
    createdUser : string;
    updatedAt : Date | any;
    updatedUser : string;
    versionFlag : number;
    id?:number;
  }
  
//   export const CreateUserDtoDefault : CreateUserDto = {
//     Id: 0,
//     username:"",
//     password:"",
//     employeeRole:EmployeeRolesEnum.ADMIN,
//     email:"",
//     employeeName:'',
//     isActive: true,
//     divisionId:0,
//     createdAt : new Date() ,
//     createdUser : '0',
//     updatedAt : new Date() ,
//     updatedUser : '0',
//     versionFlag : 1,
//     id: 0
//   };
  
  